/**
 * Frontend mirror of the backend's DEFAULT_NOTIFICATION_SETTINGS
 * (apps/partner-portal-api/src/services/notificationSettings.ts) — the
 * built-in reminder plan + delay-moment copy. The REAL source of truth is the
 * server (`notificationDefaults` on every pass-design doc); this copy exists
 * only for mock mode, which must seed the editor identically offline.
 */
import type { NotificationSettings } from '../types';

export const NOTIFICATION_DEFAULTS: NotificationSettings = {
  reminders: [
    {
      key: 't24h',
      enabled: true,
      minutesBefore: 1440,
      header: 'Készülj az útra',
      body:
        'Holnap repülsz. A pass automatikusan frissíti a gate-et, terminált és az ' +
        'esetleges késést. Érdemes ~2 órával az indulás előtt a reptéren lenni; hosszú ' +
        'késésnél megjelenik az igénylési QR.',
    },
    {
      key: 't4h',
      enabled: true,
      minutesBefore: 240,
      header: '4 óra az indulásig',
      body:
        'Indulj el a reptérre időben. Csekkolj be online, és nézd az élő járatstátuszt + ' +
        'a gate-et a passon.',
    },
    {
      key: 't30m',
      enabled: true,
      minutesBefore: 35,
      header: 'Hamarosan beszállás',
      body: 'Menj a gate-hez! A pass mutatja az élő státuszt, a gate-et és a beszállás állapotát.',
    },
  ],
  delayMoment: {
    header: 'Késés a járatodnál',
    body: 'A járatod kb. {delay} percet késik. A passon megjelent az igénylési QR-kód.',
  },
};
